module.exports = __webpack_public_path__ + "static/img/home_bluedot.80609e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_bluedot.png
// module id = 589
// module chunks = 5 6